<template>
  <div class="app-wrapper" :class="classObj">
    <sidebar class="sidebar-container"></sidebar>
    <div class="main-container">
      <navbar></navbar>
      <Tagsview></Tagsview>
      <app-main></app-main>

    </div>
  </div>
</template>

<script>
import { Navbar, Sidebar, AppMain } from './components'
import Tagsview from "@/components/tagsview/tagsview"
import ResizeMixin from './mixin/ResizeHandler'
import {mapState} from "vuex";

export default {
  name: 'layout',
  components: {
    Navbar,
    Sidebar,
    AppMain,
    Tagsview
  },
  mixins: [ResizeMixin],
  computed: {
    ...mapState(["isCollapse"]),
    sidebar() {
      return this.$store.state.app.sidebar
    },
    device() {
      return this.$store.state.app.device
    },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile'
      }
    }
  },
  watch:{
    isCollapse(){
      if(this.isCollapse){
        this.subwidth='64px'
      }else{
        this.subwidth='200px'
      }
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @use "src/styles/mixin.scss" as min;
  .app-wrapper {
    @include min.clearfix;
    position: relative;
    height: 100%;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/views/layout/Layout.vue